module.exports = __webpack_public_path__ + "img/maestro.1be6914.png";